export { NewsPage as default } from '@/components/pages/Ir/News'
